export type InternalNavLink = {
  hash?: string
  pathname: string
  link: string
  title: string
}

type MkInternalNavLinkOptions = {
  hash?: string
  pathname: string
  title: string
}

export function mkInternalNavLink(options: MkInternalNavLinkOptions): InternalNavLink {
  const { hash, pathname, title } = options
  const normalizedPathname = pathname.replace(/\/$/, '')
  const link = hash ? `${normalizedPathname}#${hash}` : normalizedPathname

  return {
    hash,
    pathname: normalizedPathname,
    title,
    link,
  }
}
